var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// import 'isomorphic-fetch'
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import Button from '../button';
import Input from '../input';
import { Styled } from './style';
var MiniMap = /** @class */ (function (_super) {
    __extends(MiniMap, _super);
    function MiniMap(props) {
        var _this = _super.call(this, props) || this;
        _this.onRemove = function (event, data) {
            _this.setState({ newLocation: '', isLoaded: false, onFocus: true });
            if (_this.props.onRemoveLocation) {
                _this.props.onRemoveLocation();
            }
        };
        _this.state = {
            newLocation: props.location,
            isLoaded: true,
            onFocus: false,
        };
        return _this;
    }
    MiniMap.prototype.onChange = function (event, data) {
        this.setState({ newLocation: data.value, isLoaded: false, onFocus: true });
    };
    MiniMap.prototype._handleKeyPress = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var newLocation, resp, data, locations;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(e.key === 'Enter')) return [3 /*break*/, 3];
                        newLocation = this.state.newLocation;
                        return [4 /*yield*/, fetch('https://maps.googleapis.com/maps/api/geocode/json?&address=' + newLocation)];
                    case 1:
                        resp = _a.sent();
                        return [4 /*yield*/, resp.json()];
                    case 2:
                        data = _a.sent();
                        console.log('resp data = ', data);
                        if (data.status === 'OK') {
                            locations = data.results[0].geometry.location.lat + ',' + data.results[0].geometry.location.lng;
                            if (this.props.onAddNewLocation) {
                                this.props.onAddNewLocation(locations);
                            }
                            this.setState({
                                newLocation: locations,
                                isLoaded: true,
                                onFocus: false,
                            });
                        }
                        else {
                            // address not found
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MiniMap.prototype.onSearchByLocation = function () {
        // todo
    };
    // 13.832860,100.595785
    MiniMap.prototype.render = function () {
        var mapsSrc = this.state.isLoaded
            ? 'http://maps.googleapis.com/maps/api/staticmap?center=' +
                this.state.newLocation +
                '&zoom=16&size=400x400&maptype=roadmap&markers=color:black%7Clabel:S%7C' +
                this.state.newLocation +
                '&key=AIzaSyB-TMXFmnSNcp52YUKI8AHSapnEsh2VBUE'
            : '';
        return (React.createElement(Styled, null,
            React.createElement("div", null,
                React.createElement("h3", null,
                    React.createElement(FormattedMessage, { id: "ui_component.mini_map.location", defaultMessage: "Location" })),
                React.createElement(Button, { className: "remove-btn", onClick: this.onRemove, transparent: true },
                    React.createElement(FormattedMessage, { id: "ui_component.common.label.remove", defaultMessage: "Remove" }))),
            React.createElement("div", { className: "mini-maps", style: { backgroundImage: 'url(' + mapsSrc + ')' } },
                React.createElement(Input, { icon: "search", fluid: true, focus: this.state.onFocus, iconPosition: "left", className: "location-input", value: this.state.newLocation, onKeyPress: this._handleKeyPress.bind(this), onChange: this.onChange.bind(this) }))));
    };
    return MiniMap;
}(React.Component));
var StyledMap = styled(MiniMap)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
Object.assign(StyledMap, {
    displayName: 'MiniMap',
});
export default StyledMap;
var templateObject_1;
//# sourceMappingURL=index.js.map